import React from "react";

interface ITitleTopicEditDrawer {
  title: string;
  marginBottom?: number;
}

const TitleTopicEditDrawer: React.FC<ITitleTopicEditDrawer> = ({
  title,
  marginBottom = 24,
}) => {
  return (
    <div style={{ marginBottom }}>
      <span style={{ color: "#fd5876", fontWeight: "bold" }}>{title}</span>
    </div>
  );
};

export default TitleTopicEditDrawer;
